import { AnyAction } from 'redux';
import { ConfirmationDialogState } from '../types/state';
import { CONFIRMATIONDIALOGACTIONS } from '../actions/confirmationDialog';

const initialState: ConfirmationDialogState = {
  open: false,
};

const confirmationDialogReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case CONFIRMATIONDIALOGACTIONS.OPEN: {
      return { ...action.payload, open: true };
    }
    case CONFIRMATIONDIALOGACTIONS.CLOSE: {
      return { open: false };
    }
    default:
      return state;
  }
};

export default confirmationDialogReducer;
